import React, { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring, AnimatePresence } from "framer-motion";

export default function Cursor() {
    const [label, setLabel] = useState(null);
    const [enabled, setEnabled] = useState(false);
    const x = useMotionValue(-100);
    const y = useMotionValue(-100);
    const sx = useSpring(x, { stiffness: 520, damping: 45, mass: 0.6 });
    const sy = useSpring(y, { stiffness: 520, damping: 45, mass: 0.6 });

    useEffect(() => {
        if (window.matchMedia("(hover: none), (pointer: coarse)").matches) return;
        setEnabled(true);
        const move = (e) => {
            x.set(e.clientX);
            y.set(e.clientY);
        };
        const over = (e) => {
            const t = e.target.closest("[data-cursor]");
            setLabel(t ? t.dataset.cursor : null);
        };
        window.addEventListener("mousemove", move, { passive: true });
        window.addEventListener("mouseover", over, { passive: true });
        return () => {
            window.removeEventListener("mousemove", move);
            window.removeEventListener("mouseover", over);
        };
    }, [x, y]);

    if (!enabled) return null;

    return (
        <motion.div
            data-testid="custom-cursor"
            className="pointer-events-none fixed left-0 top-0 z-[300] mix-blend-difference"
            style={{ x: sx, y: sy }}
        >
            <motion.div
                animate={{
                    width: label ? 64 : 10,
                    height: label ? 64 : 10,
                    backgroundColor: "rgba(255,255,255,1)",
                }}
                transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                className="flex -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full"
            >
                <AnimatePresence>
                    {label && (
                        <motion.span
                            initial={{ opacity: 0, scale: 0.6 }}
                            animate={{ opacity: 1, scale: 1 }}
                            exit={{ opacity: 0, scale: 0.6 }}
                            transition={{ duration: 0.25 }}
                            className="font-display text-[9px] font-bold uppercase tracking-[0.2em] text-[#F2F0EA]"
                        >
                            {label}
                        </motion.span>
                    )}
                </AnimatePresence>
            </motion.div>
        </motion.div>
    );
}
